import { PlannerEcsSystem, PlannerProductComponent, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import BestaOpeningFunctionComponent from '../components/BestaOpeningFunctionComponent';
export class BestaOpeningTypeSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'BestaOpeningTypeSystem', ComponentIds.IN_SCENE_COMPONENT_ID);
        this.mandatoryComponents = [PlannerProductComponent.id];
    }
    onAdd(entity) {
        if (entity.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)) {
            const doors = this.coreApi.entities.getAncestorsWithOneOfProductTypes(entity, [
                ProductType.BESTA_DOOR_192_ASM,
                ProductType.BESTA_DOOR_38_ASM,
                ProductType.BESTA_DOOR_64_ASM
            ]);
            doors?.length > 0 &&
                doors[0].addComponent(new BestaOpeningFunctionComponent(ProductType.BESTA_SOFT_CLOSING));
        }
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=BestaOpeningTypeSystem.js.map